import { put, takeLatest } from "redux-saga/effects";
import { push } from "redux-first-history";

import { ASSETS_AUDIO_ROUTE, ASSETS_IMAGES_ROUTE, ASSETS_VIDEOS_ROUTE } from "@ds/constants/router";

import { AssetTableTypeEnum } from "../utils/model";
import { assetsCommonActions } from "./common-slice";

function* switchRoute({ payload }: ReturnType<typeof assetsCommonActions.switchView>) {
  let routeToSwitch = ASSETS_VIDEOS_ROUTE;
  switch (payload) {
    case AssetTableTypeEnum.Images:
      routeToSwitch = ASSETS_IMAGES_ROUTE;
      break;
    case AssetTableTypeEnum.Audio:
      routeToSwitch = ASSETS_AUDIO_ROUTE;
      break;
  }

  yield put(push(routeToSwitch));
}

export function* watchAssetsCommon() {
  yield takeLatest(assetsCommonActions.switchView, switchRoute);
}
